const delay = (seconds: number): Promise<void> => {
  if (seconds < 0) {
    throw new Error('Delay seconds must be non-negative');
  }
  return new Promise((resolve) => setTimeout(resolve, seconds * 1000));
};

export default delay;
